import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import CheckboxCard from '../shared-components/checkbox_card';
import gameTemplateList from '../../datasets/game_template_list';
import AccountSettingsText from './text/account_settings_text';
import TextWithLearnMoreButton from '../shared-components/text_with_learnMore_button';
import buildAccountSettingsObj from './objects/build_account_settings_obj';
import beforeAfterCompare from '../../objects/CommonUse/before_after_compare';


class AccountSettingsModal extends Component {
  constructor(props) {
    super(props);
    this.state={
        openInformationModal: false,
        rerender: false,
    }    
    this.checkBoxSelect = this.checkBoxSelect.bind(this);
    this.startGameTemplateArr = [];
    this.gameTemplateText={};
    this.typeOfTest = {};
    this.prepareAccountSettingsInfo();
    this.determineAccountSettingsText();
}

prepareAccountSettingsInfo(){
    this.text1 = "";
    this.expandButtonText = "More Information";
    const gameTemplateOptions = gameTemplateList;
    for (let i=0; i<gameTemplateOptions.length; i++){
        const startGameTemplateObj = {
            selectValue: gameTemplateOptions[i].buttonName, 
            buttonText: gameTemplateOptions[i].buttonText,
            desc: gameTemplateOptions[i].desc, 
            checked: false};
        this.startGameTemplateArr.push(startGameTemplateObj);
    }
    this.updateFormValuesFromDatabase();
}

updateFormValuesFromDatabase(){
    if (this.props.accountSettingsData){
        const currentAccountSettings = this.props.accountSettingsData;
        this.testType = currentAccountSettings.testSettings.testType;
        let forceTest = "no";
        if (currentAccountSettings.testSettings.forceTest === true){
            forceTest = "yes";
        }
        this.testRequired = forceTest;
        this.nbrGames = currentAccountSettings.startGameOptions.nbrGames;
        this.updateGameTemplateChecked(currentAccountSettings.startGameOptions.gameTemplateArr);
        this.beforeSettingsObj = buildAccountSettingsObj(this.testType, this.testRequired, this.nbrGames,
            this.startGameTemplateArr)
    }else{
        this.beforeSettingsObj = {};
    }
}

updateGameTemplateChecked(DBGameTemplateArr){
    for (let i=0; i<this.startGameTemplateArr.length; i++){
        if (DBGameTemplateArr.includes(this.startGameTemplateArr[i].buttonText)){
            this.startGameTemplateArr[i].checked = true;
        }
    }
}

determineAccountSettingsText(){
    const accountSettingsDisplayText = AccountSettingsText;
    for (let i=0; i<accountSettingsDisplayText.length; i++){
        const textName = accountSettingsDisplayText[i].type;
        this[textName].text1 = accountSettingsDisplayText[i].text1;
        this[textName].text1Class = accountSettingsDisplayText[i].text1Class;
        this[textName].text2 = accountSettingsDisplayText[i].text2;
    }
}

checkBoxSelect(slctObj){
    const templateIndx = this.startGameTemplateArr.findIndex(elem => elem.buttonText === slctObj.buttonText);
    this.startGameTemplateArr[templateIndx].checked = slctObj.checked;
    this.setState({rerender: !this.state.rerender});
}

handleTestTypeChange(testType){
    this.testType = testType;
    this.setState({rerender: !this.state.rerender});
}

handleTestRequiredChange(testRequired){
    this.testRequired = testRequired;
    this.setState({rerender: !this.state.rerender});
}

handleNbrGamesChange(nbrGames){
    this.nbrGames = nbrGames;
    this.setState({rerender: !this.state.rerender});
}

render() {
      this.startGameTemplateList = this.startGameTemplateArr.map((templateList, index) =>
          <CheckboxCard key={index} itemList={templateList} 
              displayClass={" font-weight-bold"}
              onSelect={(slctObj)=> this.checkBoxSelect(slctObj)}  
          />        
      );
              
return <>
    <Modal className="text-center" show={this.props.show}  onHide={() => this.props.onClose()} 
       size="lg" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Account Settings - Account Number: &nbsp;
                {this.props.accountNbr}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
              <span>
              <h5 className="text-center table-header-background mt-4">Settings for Student Tests</h5>
                <div className="mt-4">
                   <div className="mx-4 font-weight-normal">
                      <label className="font-weight-bold" htmlFor="force-test">Test Type:&nbsp;&nbsp;
                      </label>             
                      <select value={this.testType || "none"}
                        onChange={(val) => this.handleTestTypeChange(val.target.value)}
                        className="btn btn-sm btn-outline-secondary dropdown-toggle" id="testType">
                            <option value="none">Test Unavailable</option>
                            <option value="pre-test">Pre-Test - Test Taken Before Course Begins</option>
                            <option value="mid-test">Mid-Test - Test Taken At AnyTime After Pre-Test</option>
                            <option value="post-test">Post-Test - Test Taken At Completion of Course</option>
                      </select>
                    </div>
                       <TextWithLearnMoreButton
                          expandButtonText={this.expandButtonText}
                          text1={this.typeOfTest.text1}
                          text1Class={this.typeOfTest.text1Class}
                          text2={this.typeOfTest.text2}
                      />
                </div>
                <div className="mt-4">
                    <label className="font-weight-bold" htmlFor="force-test">Test Required:&nbsp;&nbsp;
                      </label>
                    <select value={this.testRequired || "yes"}
                      onChange={(val) => this.handleTestRequiredChange(val.target.value)}
                      className="btn btn-sm btn-outline-secondary dropdown-toggle" id="forceTest">
                          <option value="yes">Test Required</option>
                          <option value="no">Not Required</option>
                    </select>
                    <div className="mx-4 text-left">
                        Choose whether students must complete the test before playing the game and before
                        receiving a course completion certificate. You can view each student's certificate 
                        status in real time on the 'Players and Settings' page. The default setting is 
                        'Test Required'.
                    </div>
                </div>
               <h5 className="text-center table-header-background mt-4">Start Game Options</h5>
               <div className="text-left mt-2 mx-4">
                   <div className="mx-4">
                      <TextWithLearnMoreButton
                        expandButtonText={this.expandButtonText}
                        text1Class={this.gameTemplateText.text1Class}
                        text1={this.gameTemplateText.text1}
                        text2={this.gameTemplateText.text2}
                      />
                  </div>
              </div>
               <div className="ml-4">
                     {this.startGameTemplateList}
               </div>
                
              <div className="text-left mb-5 mx-4 mt-4">           
                  <label className="font-weight-bold ml-4" htmlFor="nbr-games">
                    Nbr of Games Before Templates Available:&nbsp;&nbsp;
                      <select value={this.nbrGames || "1"}
                        onChange={(val) => this.handleNbrGamesChange(val.target.value)}
                        className="btn btn-sm btn-outline-secondary dropdown-toggle" id="nbrGames">
                            <option value="1">1 Game</option>
                            <option value="2">2 Games</option>
                            <option value="3">3 Games</option>
                            <option value="4">4 Games</option>
                            <option value="5">5 Games</option>
                      </select>
                  </label>
                  <div className="mt-2 ml-4">
                    If start game templates have been selected, determine how many games players
                    must complete before they will be able to choose a template.  This value will be
                    ignored if no templates have been selected.
                </div> 
               </div>
              </span>
            
                  
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
              <div className="text-danger">
                    {this.message}
              </div>
              <Button variant="primary"  onClick={() => this.processAccountSettingUpdates()}>
                   Submit
              </Button>
              <Button variant="secondary"  onClick={() => this.props.onClose()}>
                   Close
              </Button>
        </Modal.Footer>
       
    </Modal>
    
  </>
}

processAccountSettingUpdates(){
    this.message = "";
    this.getFormValues();
    let accountSettingsObj = buildAccountSettingsObj(this.testType, this.testRequired, this.nbrGames,
        this.startGameTemplateArr);
    const dataCompareObj = beforeAfterCompare("accountSettings", this.beforeSettingsObj, 
        accountSettingsObj);
    // if dataValid is false, it means that the two objects were not the same
    if (dataCompareObj.dataValid === false){
        accountSettingsObj = {accountNbr: this.props.accountNbr, ...accountSettingsObj};
        this.props.updateAccountSettings(accountSettingsObj);
        
    }else{
        this.message = "Entries match current account settings. Click 'Close' if no further changes " +
            "are required."
    }
    
}

getFormValues(){
    this.testType = document.getElementById("testType").value;
    this.testRequired = document.getElementById("forceTest").value;
    this.nbrGames = document.getElementById("nbrGames").value;
}

}
export default AccountSettingsModal;